module.exports = __webpack_public_path__ + "static/media/flowersLofi.1eaa45bd.mp3";